import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronLeftMedium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconChevronLeftMedium"><Path d="M15.9141 6L9.91406 12L15.9141 18L14.5 19.4141L7.08594 12L14.5 4.58594L15.9141 6Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronLeftMedium;
